module.exports = __webpack_public_path__ + "static/media/logo.2260cf66.svg";